import { FC } from "react";
import Highlighter from "react-highlight-words";

import {
  formatReasoningToReadable,
  stripReasoningPrefix,
} from "./ai-conversation.utils";
import { TraceContentStyled } from "./bulk-ai-advisor-drawer.styled";
import { SyntaxHighlighter } from "./syntax-highlighter";

interface ITraceDetailContentProps {
  rawReasoning: string;
  searchTerm?: string;
}

export const TraceDetailContent: FC<ITraceDetailContentProps> = ({
  rawReasoning,
  searchTerm,
}) => {
  const extracted = formatReasoningToReadable(rawReasoning);
  const readable = extracted || stripReasoningPrefix(rawReasoning || "");
  if (!readable) {
    return <TraceContentStyled>—</TraceContentStyled>;
  }

  return (
    <TraceContentStyled>
      {searchTerm?.trim() ? (
        <Highlighter
          searchWords={[searchTerm]}
          autoEscape={true}
          textToHighlight={readable}
          highlightClassName="search-highlight"
        />
      ) : (
        <SyntaxHighlighter text={readable} />
      )}
    </TraceContentStyled>
  );
};
